/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import AppCardRow from "./AppCardRow";
import { App } from "../../api/apiCalls";

export interface AppSuggestionsProps {
  title: string;
  apps?: App[];
}

export default function AppSuggestions({ title, apps }: AppSuggestionsProps) {
  return (
    <div>
      <div className="row mt-5 apps-row apps-row-vertical">
        <div className="col-lg-12 mb-5">
          <h4 className="font-weight-bold m-0">{title}</h4>
        </div>
        {apps &&
          apps.slice(0, 8).map((app) => {
            return <AppCardRow key={app.appId} app={app} />;
          })}
      </div>
    </div>
  );
}
